enum CardShippingSpeed {
  Standard = "Standard",
  Express = "Express",
}

export default CardShippingSpeed;
